export default __webpack_public_path__ + "static/media/Selo Minas Gerais 2024.b80b37b2.png";